import { mapActions } from 'vuex'

export default {
  props: {
    embedded: { type: Boolean, default: false },
    title: { type: String, default: 'Registro de Presença' },
  },
  data: () => ({
    loading: false,
    snackbar: false,
    message: '',
    error: false,
    errors: [],
    selection: 1,
    token: null,
    loadingLogout: false,
    teacher: null,
    institution: null,
    showMark: false,
    showMaps: false,
    loadingMark: false,
    sheet: null,
    position: {
      lat: 0,
      lng: 0,
    },
    showReceipt: false,
    receipt: null,
    clockStatus: null,
    serverTime: null,
    sheet: {
      id: 1,
      items: [ { date: '2022-08-01' } ]
    },
    times: [ 
      {field: 'hour_start1', label: 'Entrada Prevista', color: 'cyan'}, 
      {field: 'hour_end1', label: 'Saída Prevista', color: 'green'}, 
      // {field: 'hour_start2', color: 'pink'}, 
      // {field: 'hour_end1', color: 'amber'},
      // {field: 'hour_start3', color: 'pink'}, 
      // {field: 'hour_end3', color: 'amber'},
    ],
    isBlocked: false,
    currentToken: null,
  }),
  computed: {
    
    teacherId: function() {
      return this.teacher ? this.teacher.id : 0;
    },

    source: function() {
      return 'https://www.google.com/maps/embed/v1/view?key=AIzaSyA7BinytdPhp-aN5QbC8rwGwTHgHhdA7Rk&center=' + this.position.lat + ',' + this.position.lng + '&zoom=18';
    },

    formatedDate: function() {
      return new Date().toLocaleDateString();
    },

    /**
     * Verifica se o relógio está sincronizado com a HLB.
     */
    isClockValid: function() {
      return this.clockStatus === 'OK';
    },

    /**
     * Verifica se o usuário pode efetuar marcação de ponto.
     * Bloqueado se relógio inválido ou sem itens na folha.
     */
    canMark: function() {
      return this.isClockValid && this.sheet && this.sheet.items && this.sheet.items.length > 0;
    },

    /**
     * Formata o horário do servidor para exibição.
     */
    formattedServerTime: function() {
      if (!this.serverTime) return null;
      try {
        const date = new Date(this.serverTime);
        return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      } catch {
        return null;
      }
    },

  },
  created() {
    this.token = this.$route.query.token || localStorage.getItem('token');
    this.currentToken = this.token;
    if (this.token) {
      this.$store.dispatch('auth/ActionSetToken', this.token);
    }
    this.getData();
    this.getLocation();
  },

  mounted() {

    
  },

  methods: {
    ...mapActions('timeSheet', ['ActionShowTimeSheet', 'ActionLogout', 'ActionStoreRegisterSheetItem']),
    ...mapActions('auth', ['ActionTeacherLogout']),

    getData(){
      this.loading = true;
      this.teacher = null;
      this.institution  = null;
      this.sheet        = null;

      this.ActionShowTimeSheet({ token: this.token })
        .then((res) => {
          this.teacher      = res.data.teacher;
          this.institution  = res.data.institution;
          this.sheet        = res.data.sheet;
          this.clockStatus  = res.data.clock?.status || null;
          this.serverTime   = res.data.clock?.server_time || null;
        })
        .catch(() => {
        })
        .finally(() => {
          this.loading = false;
        });
    },

    goBack() {
      this.$router.push({ name: 'teacher-panel' });
    },

    goToTimeSheet() {
      if (this.embedded) {
        this.$emit('open-timesheet')
        return
      }
      this.$router.push({ name: 'teacher-panel', query: { open: 'timesheet' } });
    },

    logout() {
      this.loadingLogout = true;

      this.ActionTeacherLogout({ token: this.token })
        .then(() => {
          this.$router.push({ path: '/login/teacher' });
        })
        .finally(() => {
          this.loadingLogout = false;
        });
    },
    
    mark(){
        
        this.loadingMark = true;
        this.error = false;
        this.message = '';

        var payload ={
          id:           (this.sheet && this.sheet.items && this.sheet.items.length > 0) ? this.sheet.items[0].id : 0,
          localization: this.position.lat + ',' + this.position.lng,
          device:       navigator.userAgent,
        };

        this.ActionStoreRegisterSheetItem(payload)
            .then((res) => {
                this.message = res.message;
                
                // Exibir comprovante de registro de ponto se disponível
                if (res.data && res.data.receipt) {
                    this.receipt = res.data.receipt;
                    this.showReceipt = true;
                }
                
                this.getData();
            }).catch((error) => {
                this.error = true;
                // Tratar erro de relógio HLB específico
                if (error.response?.data?.errors?.clock) {
                    const clockError = error.response.data.errors.clock[0];
                    if (clockError === 'CLOCK_UNAVAILABLE') {
                        this.message = 'Sistema de relógio temporariamente indisponível. Tente novamente em alguns instantes.';
                    } else if (clockError === 'CLOCK_SKEW_EXCEEDED') {
                        this.message = 'O relógio do servidor está fora de sincronia. Tente novamente em alguns instantes.';
                    } else {
                        this.message = error.response?.data?.message || error.message;
                    }
                    // Atualizar dados para refletir novo status do clock
                    this.getData();
                } else {
                    this.message = error.response?.data?.message || error.message;
                }
            })
            .finally(() => {
              this.loadingMark = false;
              this.showMark = false;
            });
    },

    /**
     * Fecha o modal do comprovante de registro de ponto.
     */
    closeReceipt() {
        this.showReceipt = false;
        this.receipt = null;
    },

    getLocation()
    {
        
        if(!this.showMaps){
          return;
        }
      
        if (navigator.geolocation)
        {
                navigator.geolocation.getCurrentPosition((pos) => {
                  this.position.lat = pos.coords.latitude;
                  this.position.lng = pos.coords.longitude;
                });
        }
        else{
                alert("O seu navegador não suporta Geolocalização.");
        }
    },
        
  }
}